export const GET_STOCK = 'GET_STOCK';
export const GET_STOCK_FAILURE = 'GET_STOCK_FAILURE';
export const GET_STOCK_SUCCESS = 'GET_STOCK_SUCCESS';

export const getStock = companyId => ({
  type: GET_STOCK,
  payload: companyId
});

export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const closeDrawer = () => ({ type: CLOSE_DRAWER });

export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM';
export const setCurrentItem = item => ({
  type: SET_CURRENT_ITEM,
  payload: item
});

export const UPDATE_ITEM = 'UPDATE_ITEM';
export const UPDATE_ITEM_FAILURE = 'UPDATE_ITEM_FAILURE';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';

export const updateItem = data => ({ type: UPDATE_ITEM, payload: data });

export const GET_REQUIRED_ATTRIBUTES = 'GET_REQUIRED_ATTRIBUTES';
export const GET_REQUIRED_ATTRIBUTES_SUCCESS =
  'GET_REQUIRED_ATTRIBUTES_SUCCESS';
export const GET_REQUIRED_ATTRIBUTES_FAILURE =
  'GET_REQUIRED_ATTRIBUTES_FAILURE';

export const getRequiredAttributes = () => ({ type: GET_REQUIRED_ATTRIBUTES });

export const GET_PRODUCT = 'GET_PRODUCT';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAILURE = 'GET_PRODUCT_FAILURE';

export const getProduct = id => ({ type: GET_PRODUCT, payload: id });

export const REPLACE_BUFFER_QUANTITY = 'REPLACE_BUFFER_QUANTITY';
export const REPLACE_BUFFER_QUANTITY_SUCCESS =
  'REPLACE_BUFFER_QUANTITY_SUCCESS';
export const REPLACE_BUFFER_QUANTITY_FAILURE =
  'REPLACE_BUFFER_QUANTITY_FAILURE';

export const replaceBufferQuantity = data => ({
  type: REPLACE_BUFFER_QUANTITY,
  payload: data
});
